



























import {Component, namespace, Vue, Prop} from 'nuxt-property-decorator'
import gateway from '@/gateway'
import { VueGoodTable } from 'vue-good-table';
import {FormSelect} from '@frontend/components/src/FormSelect'

@Component({
  components: {
    VueGoodTable,
    FormSelect,
  }
})
class Coverage extends Vue {
  @Prop({type: Object})
  channel!: any

  coverage: any[] = []
  regions: any[] = []

  columns = [
    {
      label: 'Name',
      field: 'tag.name'
    },
    {
      label: ' ',
      field: 'remove'
    },
  ]

  async mounted () {
    const [channelResponse, regionsResponse] = await Promise.all([
      gateway.get(`cms/channels/${this.channel.id}/coverage`),
      gateway.get(`cms/regions?withGlobal=1`),
    ])

    this.coverage = channelResponse.data.data
    this.regions = regionsResponse.data.data
  }

  async removeCoverage (regionId) {
    try {
      const {data} = await gateway.delete(`cms/channels/${this.channel.id}/coverage`, {
        data: {
          regionId,
        },
      })

      this.coverage = data.data
    } catch (_) {
      console.log(_)
    }

  }

  input (option) {
    console.log(option, option.id)
    this.addCoverage(option.id)
  }

  async addCoverage (regionId) {
    try {
      const {data} = await gateway.post(`cms/channels/${this.channel.id}/coverage`, {
        regionId,
      })

      this.coverage = data.data
    } catch (_) {
      console.log(_)
    }

  }
}

export default Coverage
